// @flow

export const locale_regex: RegExp = /^[a-z]{2,4}([-][a-z]{4})?([-]([a-z]{2}|[0-9]{3}))?$/
export const simple_locale_regex: RegExp = /^[a-z]{2}-[a-za]{2}$/
export const language_alone_regex: RegExp = /^[a-z]{2}$/i